/** 빌드타임 주입 semver, 미주입(dev 등)이면 "0.0.0-dev" */
export const APP_VERSION: string = process.env.REACT_APP_VERSION || "0.0.0-dev";

/** 빌드 식별자 ISO-8601 UTC "YYYY-MM-DDTHH:mm:ssZ"(예 "2026-06-17T07:30:16Z"), 미주입이면 "" */
export const BUILD_TIMESTAMP: string = process.env.REACT_APP_BUILD_TIMESTAMP || "";

const ASSET_BASE = process.env.PUBLIC_URL ?? "";
export const VERSION_JSON_URL = `${ASSET_BASE}/version.json`;
